import type { ProfitAndLossDetailSource } from '../types/report';

const SOURCE_TYPE_LABELS: Record<string, string> = {
  INVOICE: 'Invoice',
  BILL: 'Bill',
  PAYMENT: 'Payment',
  BILL_PAYMENT: 'Bill Payment',
  JOURNAL_ENTRY: 'Journal Entry',
};

const formatLabel = (value: string) =>
  value
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export interface ReportSourceRoute {
  pathname: string;
  state?: Record<string, unknown>;
}

export const getReportSourceLabel = (source: ProfitAndLossDetailSource | null): string => {
  if (!source) return '—';
  return SOURCE_TYPE_LABELS[source.type] ?? formatLabel(source.type);
};

export const getReportSourceRoute = (
  source: ProfitAndLossDetailSource | null
): ReportSourceRoute | null => {
  if (!source) return null;

  switch (source.type) {
    case 'INVOICE':
      return { pathname: `/sales-transactions/view/invoice/${source.id}` };
    case 'BILL':
      return { pathname: `/purchase-transactions/view/bill/${source.id}` };
    case 'PAYMENT':
      return { pathname: `/sales-transactions/view/payment/${source.id}` };
    case 'BILL_PAYMENT':
      return { pathname: `/purchase-transactions/view/payment/${source.id}` };
    case 'JOURNAL_ENTRY':
    default:
      if (source.transaction_id) {
        return {
          pathname: '/accounts',
          state: {
            activeTab: 'journal',
            referenceTransactionId: source.transaction_id,
          },
        };
      }
      return null;
  }
};

export const getJournalRoute = (transactionId: number): ReportSourceRoute => ({
  pathname: '/accounts',
  state: {
    activeTab: 'journal',
    referenceTransactionId: transactionId,
  },
});
